var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emd-modal", {
    attrs: { open: _vm.isOpen, "has-header": "", "has-footer": "" },
    on: {
      close: function ($event) {
        return _vm.$emit("onClose")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("h2", { staticClass: "emd-text _size_section" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("modal.boleto-stone.modal-create-account.title")
                  ) +
                  " "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("p", [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "modal.boleto-stone.modal-create-account.paragraph-1"
                    )
                  ) +
                  " "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "footer-container" },
              [
                _c(
                  "a",
                  {
                    staticClass: "info-link",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("onCreateAccount")
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "modal.boleto-stone.modal-create-account.paragraph-2"
                          )
                        ) +
                        " "
                    ),
                    _c("emerald-icon", {
                      staticClass: "learn-more",
                      attrs: { icon: "learn-more" },
                    }),
                  ],
                  1
                ),
                _c("EmdButton", {
                  staticClass: "button",
                  attrs: {
                    color: "primary",
                    text: _vm.$t(
                      "modal.boleto-stone.modal-create-account.button"
                    ),
                    size: "big",
                    block: true,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("onCreateAccount")
                    },
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }